
import React from 'react';
import { useState, useEffect, useContext} from "react";
import { Box, Grid, Typography, Divider, TextField, Button, Switch, CircularProgress, Tooltip } from "@mui/material";
import { ColorModeContext, useMode} from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import AuthContext from "../auth/AuthProvider";
import Header from "../components/Header";
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import {api} from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import { decode } from 'base-64';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PassBook from './PassBook';
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from '@mui/material/Autocomplete';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import "mapbox-gl/dist/mapbox-gl.css";
import ReactMapGL, { Marker, NavigationControl } from 'react-map-gl';
import { toast } from 'sonner';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#edf2fb',
    ...theme.typography.body2,
    padding: '30px',
}));

const MAP_TOKEN = "pk.eyJ1IjoiYWZyaWZhNTE4IiwiYSI6ImNseW1vN3czNjFrYmMyaXM0czhhODVieXUifQ.1S2CY7jB8GfCO5OTezdeaA"

const OneMember = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const location = useLocation();
    const ID = location.state && location.state.Member_id;
    const Name = location.state && location.state.Fullname;
    const Psb = location.state && location.state.Psb;
    const [allData, setAllData] = useState([]);
    const [memberImage, setMemberImage] = useState(null);
    const [memberImageCard, setMemberImageCard] = useState(null);
    const [codedPhoto, setCodedPhoto] = useState(null);
    const [codedCard, setCodedCard] = useState(null);
    const {  permissions } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [is_farmer, setIs_farmer] = useState(false);
    const [farm_crops, setFarm_crops] = useState([]);
    const [farmer_crops, setFarmer_crops] = useState([]);
    const [land_size_acres, setLand_size_acres] = useState(null)
    const [longitude, setLongitude] = useState(-0.21775)
    const [latitude, setLatitude] = useState(9.9155)
    const [viewport, setViewport] = useState({
        latitude: 9.9155,
        longitude: -0.21775,
        zoom: 12,
        width: '100%',
        height: '100%'
      });

      const viewUr = (url) => {
        if(url){
            window.open(url, '_blank');
        }else{
            toast.warning("Address is not available");
        }
    };

      
    const doNothing = () => {
        return null
    }
    
    const fetchCrops = () => {
        const cachedCropsData = localStorage.getItem(`farmCrops_${ID}`);
      
        if (cachedCropsData) {
          setFarm_crops(JSON.parse(cachedCropsData));
        } else {
          api
            .get(`/members/farm/crops/${ID}`, {
              headers: {
                Authorization: 'Bearer ' + fetchToken(),
              },
            })
            .then(function (response) {
              setFarm_crops(response.data?.data);
      
              localStorage.setItem(`farmCrops_${ID}`, JSON.stringify(response.data?.data));
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      };
      

    const fetchMemberDetails = () => {
        const storedMemberData = localStorage.getItem(`member_${ID}`);
      
        if (storedMemberData) {
          const parsedData = JSON.parse(storedMemberData);
          setAllData(parsedData);
          setViewport({
            latitude: parsedData.lat ? parsedData.lat : latitude,
            longitude: parsedData.long ? parsedData.long : longitude,
            zoom: 15,
            width: '100%',
            height: '100%',
          });
          setLongitude(parsedData.lat ? parsedData.lat : -0.21775);
          setLatitude(parsedData.lat ? parsedData.lat : 9.9155);
          setIs_farmer(parsedData.is_farmer);
      
          const decodedImageData = decode(parsedData.Member_Image);
          setMemberImage(decodedImageData);
          const decodedCardPicData = decode(parsedData.GhCard_Image);
          setMemberImageCard(decodedCardPicData);
        } else {
          api
            .get(`/members/${ID}`, {
              headers: {
                Authorization: 'Bearer ' + fetchToken(),
              },
            })
            .then(function (response) {
              // Set state with the response data
              setAllData(response.data);
              setViewport({
                latitude: response.data.lat ? response.data.lat : latitude,
                longitude: response.data.long ? response.data.long : longitude,
                zoom: 15,
                width: '100%',
                height: '100%',
              });
              setLongitude(response.data.lat ? response.data.lat : -0.21775);
              setLatitude(response.data.lat ? response.data.lat : 9.9155);
              setIs_farmer(response.data.is_farmer);
              const decodedImageData = decode(response.data.Member_Image);
              setMemberImage(decodedImageData);
              const decodedCardPicData = decode(response.data.GhCard_Image);
              setMemberImageCard(decodedCardPicData);
      
              localStorage.setItem(`member_${ID}`, JSON.stringify(response.data));
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      };
      
      
    const mainCrop = (crop_id) => {
        const data = new FormData()
        data.append('crop_id', crop_id)
        data.append('member_id', ID)

        api.post('/members/farm/crops/main/crop', data, {
          headers: {
            Authorization: 'Bearer '+fetchToken()
          }
        }).then(function (response){
            toast.success(response.data);
            fetchMemberDetails();
        }).catch(function (error){
          console.log(error)
        })
      }
      

    const formik = useFormik({
        initialValues: {
            farmer_language: '',
            land_location: '',
            crops: [],
            member_id: ID,
            lat: null,
            long: null
      },
      validationSchema: Yup.object({
          "land_size_acres": Yup.number(),
      }),
      onSubmit: (values) => {
        const data = {
            'farmer_language': values.farmer_language,
            'land_location': values.land_location,
            'member_id': values.member_id,
            'crops': values.crops,
            'long': values.long,
            'lat': values.lat
        }

        api.post('/members/farmer/now/save', data ,{
            headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
        }).then(function (response){
            fetchMemberDetails();
            toast.success(response.data);
            formik.handleReset();
        })
      }
    })
    const [soc, setSoc] = useState();
    
    const fetch_somthing = () => {
        const cachedSocietyData = localStorage.getItem('societyData');
      
        if (cachedSocietyData) {
          setSoc(JSON.parse(cachedSocietyData));
        } else {
          api
            .get('/users/user/society', {
              headers: {
                Authorization: 'Bearer ' + fetchToken(),
              },
            })
            .then(function (response) {
              setSoc(response.data?.Soc);
              localStorage.setItem('societyData', JSON.stringify(response.data?.Soc));
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      };
      
        const handlePsb = (psb, association_id) => {
            api.get(`/association/check/society/asso/${association_id}`,{
                headers: {
                  Authorization: 'Bearer '+fetchToken()
                }
              }).then(function (response){
                  if (response.data === 'Safe'){
                    navigate('/Passbook/', {state: {
                        Member_id: ID,
                        Fullname: Name,
                        Psb: psb
                    } })
                  }else{
                    toast.warning(response.data)
                  }
              }).catch(function (error){
                console.log(error)
              })
            
        };

    useEffect(() => {
        fetchMemberDetails();
        fetch_somthing();
        fetchCrops();
    },[])

        const handleClick = (associationId) => {
            api.get(`association/${associationId}`,{
                headers :{
                    Authorization: 'Bearer '+ fetchToken()
                }
            }).then(function (response){
                if (response.status === 200 && response.data) {
                    navigate('/association/', { state: { responseData: response.data } })
                };
            });
        };

        const handleUpdateHere = () => {
            navigate('/update', {state: {
                memberImage: codedPhoto,
                cardImage: codedCard,
                allData: allData,
                Member_id: ID 
            }})
        };

        const handleUnrePsb = () => {
            navigate('/unregistered/', {state: {
                Member_id: ID,
                Fullname: Name,
            } })
        };

        const handleFarmerNow = (e) => {
            setIs_farmer(e.target.checked)
            const data = new FormData()
            data.append('is_farmer', e.target.checked);
            data.append('member_id', ID);

            api.post('/members/farmer/now', data, {
                headers :{
                  Authorization: 'Bearer '+ fetchToken()
                }
            }).catch(function (error){
                console.log(error);
            });
        }

    return (
                <div className="app">
                    <main className="content">
                        <Box sx={{m:5}}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Header title="Member"  subtitle={Name} />
                            </Box>
                            {
                                allData.First_name?
                                <Grid  container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Item sx={{ marginBottom:'30px' }}>
                                        <Grid container spacing={2}>
                                            {/* member image */}
                                            <Grid item xs={12} md={6}>
                                                <Avatar
                                                    alt="Member Image"
                                                    src={`data:image/jpeg;base64,${btoa(memberImage)}`}
                                                    sx={{ width: 296, height: 296, margin: '0 auto'}}
                                                />
                                            </Grid>
                                            {/* member card */}
                                            <Grid item xs={12} md={6}>
                                                <Card sx={{ maxWidth: 445,  margin: '0 auto' }}>
                                                    {
                                                        permissions && permissions.view_member === true?
                                                        <CardMedia
                                                            sx={{ height: 250 }}
                                                            image={`data:image/jpeg;base64,${btoa(memberImageCard)}`}
                                                            title="Ghana Card"
                                                        />
                                                        : null
                                                    }
                                                </Card>
                                            </Grid>
                                            
                                            <Grid item xs={12} md={12}>
                                                {
                                                    permissions && permissions.update_member === true ?
                                                    <Button size='small' variant='contained' sx={{ m:1, backgroundColor:'#33415c', borderRadius:4, borderRadius:4,
                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                        minWidth: 0,
                                                        '&:hover': {
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                        backgroundColor:'#80ed99',
                                                        color:'#000'
                                                        }, }} onClick={handleUpdateHere} >Update</Button>
                                                    :
                                                    null
                                                }

                                                <Grid container spacing={1}>
                                                    {
                                                        permissions && permissions.view_member === true ?
                                                            <Grid item xs={12} md={8}>
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>First Name: {allData.First_name}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Middle Name: {allData.Middle_name}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Last Name: {allData.Last_name}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Gender:</b> <Chip size='medium' variant="outlined" color="primary" label={allData.Gender} />
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Phone: {allData.Phone}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Date Of Birth: {allData.Date_Of_Birth}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Card Number: {allData.GhCard_Number}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Next Of Kin: {allData.Next_Of_Kin}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Address: {allData.Address}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Home Address (GPS): <Chip 
                                                                                                size='small'
                                                                                                label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Map</b></Typography>}
                                                                                                sx={{
                                                                                                    borderRadius: 2,
                                                                                                    m: 1,
                                                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                                                                    backgroundColor: '#2b2d42',
                                                                                                    color: '#fff',
                                                                                                    '&:hover': {
                                                                                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                                                    backgroundColor: '#14213d',
                                                                                                    },
                                                                                                }} 
                                                                                                onClick={() => viewUr(allData?.Other_Address)} 
                                                                                            /></b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Other Phone: {allData.Other_Phone}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Other Name: {allData.Other_Name}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Common name: {allData.Common_name}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Marital Status: {allData.MaritalStatus}</b> 
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Education Level: {allData.EducationLevel}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Town: {allData.Town}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Area Type: {(allData.ruralOrUrban === 'urban_area')? "Urban Area" : "Rural Area"}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Farmer Language: {allData?.farm_details[0]?.farmer_language}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Total Land Size: {allData?.farm_details[0]?.land_size_acres} {allData?.farm_details[0]?.land_size_acres <= 1?'acre':'acres' }</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Land Location: <Chip 
                                                                                                size='small'
                                                                                                label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Map</b></Typography>}
                                                                                                sx={{
                                                                                                    borderRadius: 2,
                                                                                                    m: 1,
                                                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                                                                    backgroundColor: '#2b2d42',
                                                                                                    color: '#fff',
                                                                                                    '&:hover': {
                                                                                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                                                    backgroundColor: '#14213d',
                                                                                                    },
                                                                                                }} 
                                                                                                onClick={() => viewUr(allData?.farm_details[0]?.land_location)} 
                                                                                            /></b>
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Longitude: {allData?.long}</b>
                                                                        </Typography>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Latitude: {allData?.lat}</b>
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} md={6}>
                                                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                            <b>Farmer plants: </b>
                                                                        </Typography>
                                                                        <Box 
                                                                            display='flex'
                                                                            sx={{ overflowX: 'auto', maxWidth:'550px', '&::-webkit-scrollbar': {
                                                                                    width: '3px',
                                                                                },
                                                                                '&::-webkit-scrollbar-track': {
                                                                                    background: '#f1f1f1',
                                                                                },
                                                                                '&::-webkit-scrollbar-thumb': {
                                                                                    background: '#888',
                                                                                    borderRadius: '10px',
                                                                                },
                                                                                '&::-webkit-scrollbar-thumb:hover': {
                                                                                    background: '#555',
                                                                                }}}>
                                                                        
                                                                            {
                                                                                allData?.farm_details[0]?.crops.map((teo)=>(
                                                                                    
                                                                                        teo.main_crop? 
                                                                                        <Tooltip title={'Main Crop'}>
                                                                                            <Chip key={teo.id} label={`${teo.commodity} | ${teo.land_size? `${teo.land_size} acres`: "N/A"}`} onDelete={doNothing} deleteIcon={<CheckCircleIcon />} sx={{ m:1, borderRadius:2 }} />
                                                                                        </Tooltip>
                                                                                    
                                                                                    :
                                                                                     <Chip onClick={() => mainCrop(teo.id)} key={teo.id} label={`${teo.commodity} | ${teo.land_size? `${teo.land_size} acres`: "N/A"}`} sx={{ m:1, borderRadius:2 }} />
                                                                                    
                                                                                ))
                                                                            }
                                                                        </Box>
                                                                    </Grid>
                                                                    {/* <Grid item xs={12} md={12}>
                                                                    
                                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                        <b>Farm Location</b>
                                                                        <div>
                                                                            <Tooltip title='drag to show coordinates'>
                                                                                <b>longitude: {viewport.longitude}</b>
                                                                                <b style={{ marginLeft:'30px' }}>latitude: {viewport.latitude}</b>
                                                                            </Tooltip>
                                                                        </div>

                                                                    </Typography>
                                                                       <Box sx={{ width:'100%', height:500}}>
                                                                            <ReactMapGL
                                                                                {...viewport}
                                                                                mapboxAccessToken={MAP_TOKEN}
                                                                                transitionDuration='200'
                                                                                onMove={(evt) => handleViewportChange(evt.viewState)}
                                                                                mapStyle='mapbox://styles/mapbox/satellite-v9'
                                                                            >
                                                                                <Marker
                                                                                    latitude={viewport.latitude}
                                                                                    longitude={viewport.longitude}
                                                                                />
                                                                                <NavigationControl position="bottom-right" />
                                                                            </ReactMapGL>
                                                                       </Box>
                                                                    </Grid> */}
                                                                    
                                                                    {/* Farmer Details */}
                                                                    <Grid item xs={12} md={12}>
                                                                        <Divider variant='middle' sx={{ m:2 }} />
                                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                                <b>Farmer: </b>
                                                                                <Switch
                                                                                    checked={is_farmer}
                                                                                    onChange={handleFarmerNow}
                                                                                    sx={{color:'#001845'}}
                                                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                                                />
                                                                            </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={12}>
                                        {
                                             is_farmer? 
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{ m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b style={{ marginRight:'5px' }}>Farm Location:</b>
                                                            <TextField 
                                                                size='small'
                                                                variant='standard'
                                                                placeholder='update'
                                                                name='land_location'
                                                                value={formik.values.land_location}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                error={formik.touched.land_location && Boolean(formik.errors.land_location)}
                                                                helperText={formik.touched.land_location && formik.errors.land_location}
                                                            />
                                                            <TextField 
                                                                size='small'
                                                                sx={{ m:1 }}
                                                                placeholder='Longitude'
                                                                name='long'
                                                                type='number'
                                                                inputProps={{ steps: 'any' }}
                                                                value={formik.values.long}
                                                                onChange={formik.handleChange}
                                                                helperText="Put longitude here"
                                                            />
                                                            <TextField 
                                                                size='small'
                                                                sx={{ m:1 }}
                                                                placeholder='Latitude'
                                                                name='lat'
                                                                type='number'
                                                                inputProps={{ steps: 'any' }}
                                                                value={formik.values.lat}
                                                                onChange={formik.handleChange}
                                                                helperText="Put latitude here"
                                                            />
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{ m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b style={{ marginRight:'5px' }}>Farmers Language: </b>
                                                            <TextField 
                                                                size='small'
                                                                variant='standard'
                                                                placeholder='update'
                                                                name='farmer_language'
                                                                value={formik.values.farmer_language}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                error={formik.touched.farmer_language && Boolean(formik.errors.farmer_language)}
                                                                helperText={formik.touched.farmer_language && formik.errors.farmer_language}
                                                            />
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <Typography sx={{ m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b style={{ marginRight:'5px' }}>Deals in? (crops): </b>
                                                            <Autocomplete
                                                                disablePortal
                                                                id="combo-box-demo"
                                                                options={farm_crops}
                                                                multiple
                                                                sx={{ width: 250 }}
                                                                getOptionLabel={(option) => option.commodity}
                                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                onChange={(event, value) => {
                                                                    if (value) {
                                                                        const selectedIds = value.map(option => {
                                                                            const landSizeKey = `land_size_${option.id}`;
                                                                            return { id: option.id, crop: option.commodity, [landSizeKey]: 0 };
                                                                        });
                                                                        formik.setFieldValue("crops", selectedIds)
                                                                    } else {
                                                                        formik.setFieldValue("crops", []);
                                                                    }
                                                                }}
                                                                renderInput={(params) => <TextField {...params} variant='standard' size="small" placeholder='update'/>}
                                                            />
                                                        </Typography>
                                                        
                                                        {
                                                            formik.values.crops.map((item) => (
                                                                <TextField 
                                                                    key={item.id}
                                                                    size="small"
                                                                    sx={{ m:1 }}
                                                                    value={item.land_size || null}
                                                                    name={`land_size_${item.id}`}
                                                                    label={`Acres used for ${item.crop}`}
                                                                    onChange={(event) => {
                                                                        const updatedCrops = formik.values.crops.map(crop => {
                                                                            if (crop.id === item.id) {
                                                                            const landSizeKey = `land_size_${crop.id}`;
                                                                                return { ...crop, [landSizeKey]: event.target.value };
                                                                            }
                                                                            return crop;
                                                                        });
                                                                        formik.setFieldValue("crops", updatedCrops);
                                                                    }}
                                                                />
                                                            ))
                                                        }


                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                    {
                                                        permissions && permissions.update_member === true ?
                                                        <Button size='small' variant='contained' sx={{ m:1, backgroundColor:'#33415c', borderRadius:4,
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                            minWidth: 0,
                                                            '&:hover': {
                                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                            backgroundColor:'#80ed99',
                                                            color:'#000'
                                                            }, }} onClick={formik.handleSubmit}>Save</Button>
                                                        :
                                                        null
                                                    }
                                                    </Grid>
                                                </Grid>
                                             :
                                            null
                                        }
                                    </Grid>
                                                                </Grid>
                                                            </Grid> 
                                                        :
                                                        null
                                                    }  
                                                    <Grid item xs={12} md={4}>
                                                    {
                                                        (allData.Member_Associations?.length === 0)
                                                        ? 
                                                            <Button size='small' sx={{ m:1, borderRadius:4 }} variant='contained' color='success' onClick={handleUnrePsb}>Open PassBook</Button>
                                                        :
                                                            <Accordion sx={{ borderRadius:2, marginBottom:3 }}>
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    aria-controls="panel1a-content"
                                                                    id="panel1a-header"
                                                                >
                                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                        <b>Savings Groups Joined: {allData.Member_Associations?.length}</b>
                                                                    </Typography>
                                                                </AccordionSummary>

                                                                <AccordionDetails>
                                                                    <Typography>
                                                                        {allData.Member_Associations?.map((data) => (
                                                                            <>
                                                                            <Button size='small' sx={{ m:1 }} variant='outlined' key={data.Association_Id} onClick={() => handleClick(data.Association_Id)}>
                                                                                {data.AssociationName}
                                                                            </Button>

                                                                            <Button  
                                                                                size='small' 
                                                                                sx={{   m:1, 
                                                                                        borderRadius:4,
                                                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                                                                        minWidth: 0,
                                                                                        '&:hover': {
                                                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                                        backgroundColor:'#80ed99',
                                                                                        color:'#000'
                                                                                        },
                                                                                     }} 
                                                                                variant='contained' 
                                                                                color='success' 
                                                                                onClick={() => handlePsb(data.Psb, data.Association_Id)}
                                                                            >
                                                                                Open PassBook
                                                                            </Button>

                                                                            <Divider variant='middle' sx={{ marginTop:'10px', marginBottom: '10px' }} />
                                                                            </>
                                                                        ))}
                                                                    </Typography>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                    }
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        
                                    </Item>
                                </Grid>
                            </Grid>
                            :
                            <Typography sx={{ textAlign:'center', m:'auto' }} variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Fetching Member Data  
                                <CircularProgress size={20}/></b>
                            </Typography>
                            }

                       </Box>
                   </main>
                </div>
)};

export default OneMember;
